<template>
  <ButtonSecondary class="flex items-center">
    <IconPlus class="mr-1 size-4" />
    <slot />
  </ButtonSecondary>
</template>
